import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../layouts/Header'

const PrivateRoute = () => {

    return <div className='bg-login_pattern min-h-screen'>
        <Header />
        <Outlet />
    </div>;
}

export default PrivateRoute
